import { gql } from '@apollo/client';

export const GET_USER = gql`
  query GetUser($where: UserWhereInput!) {
    getUser(where: $where) {
      id
      username
      metadata
      wallets {
        flow {
          address
          chain
          isPrimary
        }
        ethereum {
          address
          chain
          isPrimary
        }
      }
      metadata
    }
  }
`;
